import { put, call } from 'redux-saga/effects';
import { fromJS } from 'immutable';

// API Calls
import { getDeliveryMethods } from "../api/checkoutApi";

// Actions
import { fetchDeliveryMethodsSuccess, fetchDeliveryMethodsFail } from '../actions/actionCreators';

export function* deliveryMethods({ payload }) {
  try {
    const result = yield call(() => getDeliveryMethods(payload));
    yield put(fetchDeliveryMethodsSuccess(fromJS(result)));
  } catch (error) {
    yield put(fetchDeliveryMethodsFail(error));
  }
}



// WEBPACK FOOTER //
// ./src/sagas/deliveryMethods.js